// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
export { MicroApp } from './MicroApp';
export { MicroAppWithMemoHistory } from './MicroAppWithMemoHistory';
